import { Header, Link, Spinner } from '@amzn/awsui-components-react';
import React, { ReactNode, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { logger } from 'modules/core';
import { awsRumService } from 'rum-service';

export enum Card {
    CreateSpendDistribution = 'CreateSpendDistribution',
    SoftClosePOs = 'SoftClosePOs',
    ConfirmReceipts = 'ConfirmReceipts',
    ReceivePOLines = 'ReceivePOLines',
    ViewRBNI = 'ViewRBNI',
    POsNeedingAttention = 'POsNeedingAttention',
    TopAccounts = 'TopAccounts'
}

export const i18nStrings = {
    dragHandleAriaLabel: 'dragHandleAriaLabel',
    dragHandleAriaDescription: 'dragHandleAriaDescription',
    resizeHandleAriaLabel: 'resizeHandleAriaLabel',
    resizeHandleAriaDescription: 'resizeHandleAriaDescription'
};

type PanelChangeHandlerFn = (key: Card, ...args: unknown[]) => void;

export interface CardBaseProps {
    onPanelChange: PanelChangeHandlerFn;
}

interface CardHeaderProps extends CardBaseProps {
    dataHeaderId: Card;
    children: ReactNode;
}

export const CardHeader: React.FC<CardHeaderProps> = ({ dataHeaderId, children, onPanelChange }) => {
    const handlePanelChange = useCallback(() => {
        onPanelChange(dataHeaderId);
    }, [dataHeaderId, onPanelChange]);

    return (
        <Header
            data-header-id={dataHeaderId}
            info={
                <Link onClick={handlePanelChange} variant="info">
                    Info
                </Link>
            }
        >
            {children}
        </Header>
    );
};

type NavigableDivProps = {
    dataLinkId: Card;
    children: ReactNode;
    url: string;
    isPending: boolean;
    error: Error | null;
};

export const NavigableDiv = ({ dataLinkId, children, url, isPending, error }: NavigableDivProps) => {
    const navigate = useNavigate();

    if (error) {
        logger.error(error);
    }

    const handleClick = () => {
        awsRumService.logHomeItemClick(dataLinkId);
        navigate(url);
    };

    return isPending || error != null ? (
        <Spinner />
    ) : (
        <div data-link-id={dataLinkId} style={{ cursor: 'pointer', height: '100%' }} onClick={handleClick}>
            {children}
        </div>
    );
};

export { CreateSpendDistribution } from './CreateSpendDistribution';
export { SoftClosePOs } from './SoftClosePOs';
export { ConfirmReceipts } from './ConfirmReceipts';
export { ReceivePOLines } from './ReceivePOLines';
export { ViewRBNI } from './ViewRBNI';
export { POsNeedingAttention } from './POsNeedingAttention';
export { TopAccounts } from './TopAccounts';
